export default {
  cookieConsent: {
    ariaLabel: "Cookie notice",
    title: "Your privacy, seriously",
    bodyPre: "HelixScan only uses ",
    bodyEssential: "essential",
    bodyMid: " storage in your browser (to keep you signed in and remember your preferences). ",
    bodyNoAds: "We don't use advertising cookies",
    bodyPost: " and, as of today, no analytics either. If we ever add usage measurement, it will only be enabled if you accept it here. ",
    policyLink: "Cookie policy",
    essentialOnly: "Essentials only",
    acceptAll: "Accept all",
  },
};
